import { createApi } from '@reduxjs/toolkit/query/react';

import { retryingBaseQuery } from '@Lib/types/api';

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
  reducerPath: 'baseApi',
  keepUnusedDataFor: 10 * 60,
  refetchOnMountOrArgChange: true,
  baseQuery: retryingBaseQuery(),
  endpoints: () => ({}),
  tagTypes: [
    'AppConfig',
    'Company',
    'User',
    'Addresses',
    'Wishlist',
    'Purchase',
    'PageForCompany',
    'PageForCompanyCategory',
  ],
});
